<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    const bikesGarageForm = this.$refs.form;
    this.$nextTick(() => {
      if (bikesGarageForm) {
        bikesGarageForm.addEventListener('submit', () => {
          this.startLoading();
        });
      }
    });
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
  },
};
</script>
